import { render, staticRenderFns } from "./media-edit-modal.vue?vue&type=template&id=4c9a4edb"
import script from "./media-edit-modal.vue?vue&type=script&lang=js"
export * from "./media-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports